var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_583_2247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.17831 18.5845C5.25484 18.3621 5.38106 18.16 5.54739 17.9937L19.4578 4.08334C20.3039 3.2372 21.6758 3.2372 22.5219 4.08334C23.368 4.92948 23.368 6.30133 22.5219 7.14747L8.61129 21.0581C8.44506 21.2243 8.24313 21.3505 8.02085 21.427L4.28658 22.713C4.04278 22.7969 3.80922 22.5634 3.89312 22.3196L5.17831 18.5845Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.85714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9531 6.19055L20.4293 8.66674",
    stroke: "#4A4A4A",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_583_2247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlogIcon);
export default __webpack_public_path__ + "static/media/edit-blog-icon.b669811a18463017dd75dc29438f383b.svg";
export { ForwardRef as ReactComponent };